/*
 * Created on Thu Oct 12 2023 10:20:04 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

/**
 * @file config/keys.jsx
 * @description Frontend configuration file to handle environment-specific URLs.
 *              Automatically sets the base URL for local development or deployed environments (DEV/UAT/PROD).
 *              Exports final URL for use in API/server calls.
 */

const { origin, hostname } = window.location;

/**
 * ENV setup
 */
const ENV = process.env.REACT_APP_ENV || 'production';
const IS_LOCAL = ENV === 'local';

/**
 * Local ports
 */
const LOCAL_STDNT_MNG_PORT = process.env.REACT_APP_STDNT_MNG_PORT || '5000';
const LOCAL_PAYMENT_PORT = process.env.REACT_APP_PAYMENT_PORT || '7000';
const LOCAL_DECISION_PORT = process.env.REACT_APP_DECISION_PORT || '5054';

/**
 * Local event service port
 */
const LOCAL_EVENT_PORT = process.env.REACT_APP_EVENT_PORT || '8083';

/**
 * Event service URL
 */
const EVENT_URL = IS_LOCAL
  ? `http://localhost:${LOCAL_EVENT_PORT}`
  : process.env.REACT_APP_EVENT_URL || origin;


/**
 * Backend API base URL
 */
const BASE_URL = IS_LOCAL
  ? `http://localhost:${LOCAL_STDNT_MNG_PORT}`
  : process.env.REACT_APP_API_URL || origin;

/**
 * Payment service URL
 */
const PAYMENT_URL = IS_LOCAL
  ? `http://localhost:${LOCAL_PAYMENT_PORT}`
  : process.env.REACT_APP_PAYMENT_URL || origin;

/**
 * Decision service URL
 */
const DECISION_URL = IS_LOCAL
  ? `http://localhost:${LOCAL_DECISION_PORT}`
  : process.env.REACT_APP_DECISION_URL || origin;

const AI_URL = process.env.REACT_APP_AI_API_URL || 'http://localhost:8000';
const AI_API_KEY = process.env.REACT_APP_AI_API_KEY || '';

/**
 * Final API URL (kept for backward compatibility)
 */
const URL = BASE_URL;

/**
 * Exports
 */
const config = {
  ENV,
  IS_LOCAL,
  BASE_URL,
  URL,
  PAYMENT_URL,
  DECISION_URL,
  EVENT_URL,
  AI_URL,
  AI_API_KEY,
  DOMAIN: hostname,
};

export default config;


